import type { SpinResponse } from "@slot/client-engine";
import { MergeRoundBuilder } from "../../MergeRoundBuilder";
import { OFFLINE_ROUND } from "../offlineRound";

/** The board clears, the new board drops in, no cluster: the spin ends at once. */
export function noWin(): SpinResponse {
  return new MergeRoundBuilder({ roundId: "merge-no-win", ...OFFLINE_ROUND })
    .baseSpin({
      board: [
        ["L2", "H1", "L3", "L1", "H3", "L4"],
        ["L4", "L1", "H2", "L3", "L2", "H1"],
        ["H4", "L3", "L1", "L4", "H1", "L2"],
        ["L1", "L2", "H3", "L2", "L3", "L1"],
        ["H2", "L4", "L1", "H4", "L1", "H2"],
        ["L3", "H1", "L2", "L1", "L4", "L3"],
      ],
      refill: [[], [], [], [], [], []],
    })
    .build();
}
